// All comments in English.
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getProducts } from "../api/products";

function useDebounced<T>(value: T, delay = 300) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setV(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return v;
}

/** Product type-in search with debounce and client-side filtering. */
export function useProductSearch(initial = "") {
  const [keyword, setKeyword] = useState(initial);
  const debounced = useDebounced(keyword, 250);

  const query = useQuery({
    queryKey: ["products", debounced],
    queryFn: () =>
      getProducts({
        q: debounced,
        limit: 20,
        includeSeatBands: true,
      }),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  // Normalize to array defensively.
  const list: any[] = Array.isArray(query.data)
    ? (query.data as any[])
    : Array.isArray((query.data as any)?.items)
    ? ((query.data as any).items as any[])
    : [];

  const options = list.map((p) => ({
    label: p.product,
    value: p.product,
  }));

  return {
    keyword,
    setKeyword,
    options,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
